module.exports = __webpack_public_path__ + "img/default_stu.69b73f53.png";